<script>
import Details from '@/views/Application/Manage/Accounts/Account/Details'
import { READ } from '@/plugins/user'

export default {
  extends: Details,
  data () {
    return {
      breadcrumb: {
        name: 'Details',
        route: { name: 'customerservice-accounts-account-details', params: { accountId: this.$route.params.accountId } }
      },
      actions: [
        {
          hidden: this.$user.cannot(READ, 'menu_manage'),
          name: 'Manage',
          icon: ['fal', 'arrow-right'],
          event: () => {
            this.$router.push({
              name: 'manage-accounts-account',
              params: { accountId: this.$route.params.accountId }
            })
          }
        }
      ]
    }
  }
}
</script>
